<script setup lang="ts">
import { computed, watchEffect, inject, Ref, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSteps } from '/@src/composable/useSteps'
import * as apisPortal from '/@src/client-portal/api'
import { NazvyKrokov } from '/@src/utils/zoppm/types'
import { useFormValues } from 'vee-validate'
import { formatDateString } from '/@src/utils/format'
import { Subjekt, ZoPPM } from '/@src/client-portal'
import { ZoppmSchemeTransformer } from '/@src/utils/zoppm'
import { NazvyAssemblySekcii } from '/@src/utils/zoppm/ZoppmSchemeTransformer/types'
import { getOrganizacieApi, getOsobyApi } from '/@src/composable/useApis'
import {
  OsobaRef,
  OrganizaciaRef,
  OsobaCreate,
  OrganizaciaCreate,
} from '/@src/client-public'

export interface PartneriProjektuFo {}

defineProps<PartneriProjektuFo>()

const { t } = useI18n()
const steps = useSteps()
const formValues = useFormValues()
const getApi = new apisPortal.SubjektyApi()
const organizaciaData = ref()
const bankoveSpojenie = ref()
const partneriProjektu = ref()
const partneriDataFO = ref()
const partneriDataPO = ref()
const subjektDetail = inject<Ref<Subjekt>>('subjektDetail')
const stavPodana = inject<boolean>('stavPodana', false)
const zoppmDetail = inject<Ref<ZoPPM>>('zoppmDraftDetail')
const dataOsoba = ref<OsobaCreate[]>([])

function format(inputDate) {
  let date = new Date(inputDate)
  if (!isNaN(date.getTime())) {
    return date.getFullYear()
  }
}

watchEffect(async () => {
  partneriDataFO.value = []
  partneriDataPO.value = []

  if (formValues.value.projekt?.partneri !== undefined) {
    for (let k = 0; k < formValues.value.projekt.partneri.length; k++) {
      if (formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']) {
        let adresa = ''

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.ulica != undefined
            ? formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                .primarnaAdresa.ulica + ' '
            : ''

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.orientacneCislo != ''
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                .primarnaAdresa.orientacneCislo
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.orientacneCislo != '' &&
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.supisneCislo != ''
        ) {
          adresa += '/'
        }

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.supisneCislo != ''
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                .primarnaAdresa.supisneCislo +
              ', '
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.orientacneCislo != '' &&
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.supisneCislo == ''
        ) {
          adresa += ', '
        }

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.psc != undefined
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                .primarnaAdresa.psc +
              ', '
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.obecZahranicie != undefined
        ) {
          adresa +=
            '' +
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
              ?.primarnaAdresa.obecZahranicie +
            ', '
        } else {
          adresa +=
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
              ?.primarnaAdresa?.obec != undefined
              ? '' +
                formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                  .primarnaAdresa.obec.nazov +
                ', '
              : ''
        }
        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']?.primarnaAdresa
            ?.stat != undefined
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
                .primarnaAdresa.stat.nazov
            : ''
        let titulyPredMeno = ''
        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
            .titulyPredMenom != null
        ) {
          var titulyPredMenoArray = Object.keys(
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
              .titulyPredMenom
          ).map(function (key) {
            return formValues
              ?.value?.projekt.partneri[k]?.partnerSubjektu['osoba'].titulyPredMenom[key].nazov
          })
          titulyPredMeno = titulyPredMenoArray.join(' ') + ' '
        }

        let titulyZaMeno = ''
        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
            .titulyZaMenom != null
        ) {
          var titulyZaMenoArray = Object.keys(
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba'].titulyZaMenom
          ).map(function (key) {
            return formValues
              ?.value?.projekt.partneri[k]?.partnerSubjektu['osoba'].titulyZaMenom[key].nazov
          })
          titulyZaMeno = ' ' + titulyZaMenoArray.join(' ')
        }
        let newOsobaFo = {
          meno:
            titulyPredMeno +
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba'].meno +
            ' ' +
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba'].priezvisko +
            titulyZaMeno,
          adresaUplna: adresa,
          rokNarodenia: format(
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
              .datumNarodenia
          ),
          statnaPrislusnost:
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osoba']
              .statnaPrislusnost.nazov,
        }
        partneriDataFO.value.push(newOsobaFo)
      }

      if (formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osobaRef']) {
        dataOsoba.value = []
        await getOsobyApi()
          .portalGetOsobaOsoby(
            formValues.value.projekt.partneri[k]?.partnerSubjektu['osobaRef']
              .osobaId as string
          )
          .then((response) => {
            dataOsoba.value = response.data
          })
          .catch(console.error)
        let newOsobaFo = {
          meno: dataOsoba.value['menoUplne'],
          adresaUplna:
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osobaRef']
              .adresaUplna,
          rokNarodenia: format(
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['osobaRef']
              .datumNarodenia
          ),
          statnaPrislusnost: dataOsoba.value['statnaPrislusnost']['nazov'],
        }

        partneriDataFO.value.push(newOsobaFo)
      }

      if (formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']) {
        let adresa = ''

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.ulica != undefined
            ? formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
                .ulica + ' '
            : ''

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.orientacneCislo != ''
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
                .orientacneCislo
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.orientacneCislo != '' &&
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.supisneCislo != ''
        ) {
          adresa += '/'
        }

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.supisneCislo != ''
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
                .supisneCislo +
              ', '
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.orientacneCislo != '' &&
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.supisneCislo == ''
        ) {
          adresa += ', '
        }

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.psc != undefined
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
                .psc +
              ', '
            : ''

        if (
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.okresZahranicie != undefined
        ) {
          adresa +=
            '' +
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
              .okresZahranicie +
            ', '
        } else {
          adresa +=
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
              ?.obec != undefined
              ? '' +
                formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']
                  .sidlo.obec.nazov +
                ', '
              : ''
        }

        adresa +=
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia']?.sidlo
            ?.stat != undefined
            ? '' +
              formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].sidlo
                .stat.nazov
            : ''

        let newOsobaPo = {
          nazov:
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].nazov,
          adresaUplna: adresa,
          ico: formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].ico,
          dic: formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizacia'].dic,
          platcaDph: formValues?.value?.projekt.partneri[k]?.partnerSubjektu[
            'organizacia'
          ].jePlatcaDph
            ? 'Áno'
            : 'Nie',
        }

        partneriDataPO.value.push(newOsobaPo)
      }

      if (formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizaciaRef']) {
        dataOsoba.value = []

        let response = await getOrganizacieApi().portalGetOrganizaciaOrganizacie(
          formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizaciaRef']
            .organizaciaId
        )
        dataOsoba.value = response.data

        let newOsobaPo = {
          nazov: dataOsoba.value['nazov'],
          adresaUplna:
            formValues?.value?.projekt.partneri[k]?.partnerSubjektu['organizaciaRef']
              .adresaUplna,
          ico: dataOsoba.value['ico'],
          dic: dataOsoba.value['dic'],
          platcaDph: dataOsoba.value['jePlatcaDph'] ? 'Áno' : 'Nie',
        }

        partneriDataPO.value.push(newOsobaPo)
      }
    }
  }
})

const schemeTransformer = inject<Ref<ZoppmSchemeTransformer>>('schemeTransformer')
const sekciaRefNazov: NazvyAssemblySekcii = 'zoppm.ss.partner-fo'
const heading = computed(
  () =>
    schemeTransformer?.value.getSectionTitle(sekciaRefNazov) ||
    t('zoppm.zhrnutie.partneriProjektu.mainHeading')
)
const isEnabled = computed(() =>
  schemeTransformer?.value.isSectionEnabled(sekciaRefNazov)
)
</script>

<template>
  <div v-if="isEnabled">
    <IDSKHeading as="h2" variant="l" class="mb-7"> {{ heading }}</IDSKHeading>

    <template v-if="partneriDataFO.length == 0 && partneriDataPO.length == 0">
      <IDSKWarningTextCustom variant="warningInfoNoBtn" class="mb-4 pr-2">
        {{ t('zoppm.zhrnutie.partneriProjektu.neboliPartneri') }}
      </IDSKWarningTextCustom>
    </template>

    <template v-if="partneriDataFO.length > 0">
      <IDSKHeading as="h3" variant="m" class="mt-7">{{
        t('zoppm.zhrnutie.partneriProjektu.prehladFo')
      }}</IDSKHeading>

      <IDSKTable
        :id="`zoznam-partnerov-fo-zhrnutie-tabulka`"
        :columns="{
          meno: t('globalne.meno'),
          adresaUplna: t('zoppm.step7.fyzickaOsoba.pobyt'),
          rokNarodenia: t('globalne.rokNarodenia'),
          statnaPrislusnost: t('globalne.statnaPrislusnost'),
        }"
        :data="partneriDataFO"
      >
        <template #cell(meno)="{ value }">
          {{ value }}
        </template>
        <template #cell(adresa)="{ value }">
          {{ value }}
        </template>
        <template #cell(rokNarodenia)="{ value }">
          {{ value }}
        </template>
        <template #cell(statnaPrislusnost)="{ value }">
          {{ value }}
        </template>
      </IDSKTable>
    </template>

    <template v-if="partneriDataPO.length > 0">
      <br />
      <IDSKHeading as="h3" variant="m">{{
        t('zoppm.zhrnutie.partneriProjektu.prehladPo')
      }}</IDSKHeading>

      <IDSKTable
        :id="`zoznam-partnerov-po-zhrnutie-tabulka`"
        :columns="{
          nazov: t('globalne.nazov'),
          adresaUplna: t('zoppm.step7.fyzickaOsoba.pobyt'),
          ico: t('globalne.ico'),
          dic: t('globalne.dic'),
          platcaDph: t('globalne.platcaDph'),
        }"
        :data="partneriDataPO"
      >
        <template #cell(nazov)="{ value }">
          {{ value }}
        </template>
        <template #cell(adresa)="{ value }">
          {{ value }}
        </template>
        <template #cell(ico)="{ value }">
          {{ value }}
        </template>
        <template #cell(dic)="{ value }">
          {{ value }}
        </template>
        <template #cell(platcaDph)="{ value }">
          {{ value }}
        </template>
      </IDSKTable>
    </template>
    <div v-if="!stavPodana" class="d-flex align-items-right">
      <IDSKButton
        variant="secondary"
        type="button"
        :data-test-id="`zoppm-partneri-projektu-fo-edit`"
        @click="
          () =>
            steps.setStep(NazvyKrokov['identifikaciaPartnerovProjektu'], {
              ref: NazvyKrokov['zhrnutie'],
            })
        "
      >
        {{ t('zoppm.zhrnutie.editBtn') }}
      </IDSKButton>
    </div>
    <hr class="mb-8 mt-8" />
  </div>
</template>
